import React, { useCallback } from 'react';
import { InstagramCreator } from '@frontend/gql/social/graphql';
import { CreatorPostsCard } from './creator-posts-card';

interface SimilarCreatorsSectionProps {
  discoveredCreators: InstagramCreator[] | null;
  onCreatorClick: (creator: InstagramCreator) => void;
}

export const SimilarCreatorsSection: React.FC<SimilarCreatorsSectionProps> = ({
  discoveredCreators,
  onCreatorClick,
}) => {
  const isEmpty = !discoveredCreators || discoveredCreators.length === 0;

  const getHandleKeyDown = useCallback(
    (creator: InstagramCreator) => (event: React.KeyboardEvent<HTMLDivElement>) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault(); // Prevent default browser action (e.g., scrolling on space)
        onCreatorClick(creator);
      }
    },
    [onCreatorClick] // Dependency: onCreatorClick ensures the function is stable if onCreatorClick is stable
  );

  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold mb-4">Similar Creators</h2>
      {isEmpty ? (
        <div className="text-center text-gray-500">
          <p>No similar creators found.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {discoveredCreators?.map((creator) => (
            <div
              key={creator.id}
              onClick={() => onCreatorClick(creator)}
              className="cursor-pointer"
              role="button"
              aria-label={`View details for ${creator.username || 'creator'}`}
              tabIndex={0}
              onKeyDown={getHandleKeyDown(creator)}
            >
              <CreatorPostsCard creator={creator} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
